// Seed data for the unified Product & Commission Configuration system
// Simulates imoney.my API catalog + initial product configs + audit log

// ─── Simulated imoney.my API Product Catalog ───────────────────────
export const apiProductCatalog = [
  // Personal Loan
  { productCode: 'IMY-PL-RHB-001', category: 'personal_loan', lenderName: 'RHB', productName: 'RHB Easy-Pinjaman Ekspres', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: 50000, rate: 1.5 }, { min: 50001, max: 200000, rate: 1.2 }, { min: 200001, max: null, rate: 0.8 }] },
  { productCode: 'IMY-PL-ALL-001', category: 'personal_loan', lenderName: 'ALLIANCE', productName: 'Alliance CashVantage Personal Financing', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: 50000, rate: 1.3 }, { min: 50001, max: 200000, rate: 1.0 }] },
  { productCode: 'IMY-PL-ARJ-001', category: 'personal_loan', lenderName: 'AL RAJHI', productName: 'Al Rajhi Personal Financing-i', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: 100000, rate: 1.8 }, { min: 100001, max: null, rate: 1.2 }] },
  { productCode: 'IMY-PL-MBSB-001', category: 'personal_loan', lenderName: 'MBSB', productName: 'MBSB Personal Financing-i', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: 50000, rate: 1.4 }, { min: 50001, max: null, rate: 1.0 }] },

  // Credit Card
  { productCode: 'IMY-CC-RHB-GOLD', category: 'credit_card', lenderName: 'RHB', productName: 'RHB Cashback Gold Mastercard', suggestedType: 'per_case', suggestedPerCase: 50 },
  { productCode: 'IMY-CC-RHB-PLAT', category: 'credit_card', lenderName: 'RHB', productName: 'RHB Cashback Platinum Visa', suggestedType: 'per_case', suggestedPerCase: 100 },
  { productCode: 'IMY-CC-MBB-PET', category: 'credit_card', lenderName: 'Maybank', productName: 'Maybank Petronas Visa Card', suggestedType: 'per_case', suggestedPerCase: 80 },
  { productCode: 'IMY-CC-OCBC-TIT', category: 'credit_card', lenderName: 'OCBC', productName: 'OCBC Titanium Rewards Card', suggestedType: 'per_case', suggestedPerCase: 80 },
  { productCode: 'IMY-CC-ALL-VIP', category: 'credit_card', lenderName: 'ALLIANCE', productName: 'Alliance Visa Platinum', suggestedType: 'per_case', suggestedPerCase: 60 },

  // Housing Loan
  { productCode: 'IMY-HL-MBSB-001', category: 'housing_loan', lenderName: 'MBSB', productName: 'MBSB Home Financing-i', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: 500000, rate: 0.5 }, { min: 500001, max: null, rate: 0.4 }] },
  { productCode: 'IMY-HL-HLB-001', category: 'housing_loan', lenderName: 'HLB', productName: 'Hong Leong MortgagePlus', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: 500000, rate: 0.45 }, { min: 500001, max: null, rate: 0.35 }] },
  { productCode: 'IMY-HL-OCBC-001', category: 'housing_loan', lenderName: 'OCBC', productName: 'OCBC Home Loan', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: 500000, rate: 0.5 }, { min: 500001, max: null, rate: 0.4 }] },
  { productCode: 'IMY-HL-RHB-001', category: 'housing_loan', lenderName: 'RHB', productName: 'RHB MyHome Financing', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: 500000, rate: 0.5 }, { min: 500001, max: null, rate: 0.4 }] },
  { productCode: 'IMY-HL-HSBC-001', category: 'housing_loan', lenderName: 'HSBC', productName: 'HSBC HomeSmart', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: 500000, rate: 0.55 }, { min: 500001, max: null, rate: 0.45 }] },

  // Property
  { productCode: 'IMY-PROP-001', category: 'property', lenderName: 'iMoney Property', productName: 'iMoney Property Marketplace', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: null, rate: 2.0 }] },

  // Business Loan
  { productCode: 'IMY-BL-FS-001', category: 'business_loan', lenderName: 'Funding Societies', productName: 'Funding Societies SME Loan', suggestedType: 'per_case', suggestedPerCase: 1500 },
  { productCode: 'IMY-BL-RHB-001', category: 'business_loan', lenderName: 'RHB', productName: 'RHB BizPower SME Loan', suggestedType: 'per_case', suggestedPerCase: 2000 },
  { productCode: 'IMY-BL-CAP-001', category: 'business_loan', lenderName: 'Capbay', productName: 'Capbay Invoice Financing', suggestedType: 'per_case', suggestedPerCase: 1200 },

  // Government Loan
  { productCode: 'IMY-GL-OSK-001', category: 'government_loan', lenderName: 'OSK', productName: 'OSK Government Staff Financing', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: null, rate: 0.8 }] },
  { productCode: 'IMY-GL-MBSB-001', category: 'government_loan', lenderName: 'MBSB', productName: 'MBSB Civil Servant Loan', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: null, rate: 0.9 }] },
  { productCode: 'IMY-GL-BSN-001', category: 'government_loan', lenderName: 'BSN', productName: 'BSN MyRinggit-i', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: null, rate: 0.75 }] },
  { productCode: 'IMY-GL-COOP-001', category: 'government_loan', lenderName: 'Coop', productName: 'Koperasi Public Servant Financing', suggestedType: 'percentage', suggestedTiers: [{ min: 0, max: null, rate: 0.7 }] },

  // Micro Loan
  { productCode: 'IMY-ML-TMB-001', category: 'micro_loan', lenderName: 'Tamabadana', productName: 'Tamabadana Micro Financing', suggestedType: 'per_case', suggestedPerCase: 150 },
  { productCode: 'IMY-ML-INS-001', category: 'micro_loan', lenderName: 'Instaduit', productName: 'Instaduit Express Micro Loan', suggestedType: 'per_case', suggestedPerCase: 120 },
  { productCode: 'IMY-ML-EM-001', category: 'micro_loan', lenderName: 'Emicro', productName: 'Emicro Digital Micro Credit', suggestedType: 'per_case', suggestedPerCase: 100 },
];

// ─── Product Categories Master List ────────────────────────────────
export const PRODUCT_CATEGORIES = [
  { key: 'personal_loan', label: 'Personal Loan', color: '#1565C0' },
  { key: 'credit_card', label: 'Credit Card', color: '#C62828' },
  { key: 'housing_loan', label: 'Housing Loan', color: '#2E7D32' },
  { key: 'property', label: 'Property', color: '#E65100' },
  { key: 'business_loan', label: 'Business Loan', color: '#4527A0' },
  { key: 'government_loan', label: 'Government Loan', color: '#006064' },
  { key: 'micro_loan', label: 'Micro Loan', color: '#AD1457' },
];

// ─── Contract Status Helpers ───────────────────────────────────────
export function computeContractStatus(expireDate, approvalStatus) {
  if (approvalStatus === 'pending_l1' || approvalStatus === 'pending_l2') return approvalStatus;
  if (approvalStatus === 'rejected') return 'rejected';
  if (approvalStatus === 'paused') return 'paused';

  const now = new Date();
  const expire = new Date(expireDate);
  const daysLeft = Math.floor((expire - now) / (1000 * 60 * 60 * 24));

  if (daysLeft < 0) return 'expired';
  if (daysLeft <= 30) return 'expiring_soon';
  return 'active';
}

export function daysUntilExpiry(expireDate) {
  const now = new Date();
  const expire = new Date(expireDate);
  return Math.floor((expire - now) / (1000 * 60 * 60 * 24));
}

// ─── Initial Product Configs (seed data) ───────────────────────────
// These represent products already imported and active
const today = new Date();
const toISO = (date) => date.toISOString().slice(0, 10);
const addMonths = (date, months) => {
  const d = new Date(date);
  d.setMonth(d.getMonth() + months);
  return d;
};

// ─── Demo recipient directory (used for commission seed) ───────────
// These IDs map to actual users in mockData.js after role migration
const RECIPIENTS = {
  // Partners (corporate_partner → partner in demoDatabase role migration)
  PARTNER_1: { id: 'USR007', name: 'Lee Chong Wei', role: 'partner' },
  PARTNER_2: { id: 'USR014', name: 'Lim Boon Keat', role: 'partner' },
  PARTNER_3: { id: 'USR018', name: 'Ong Jia Hui', role: 'partner' },
  // Individual agents (agent → individual_agent after role migration)
  AGENT_1: { id: 'USR002', name: 'Siti Nurhaliza binti Ismail', role: 'individual_agent' },
  AGENT_2: { id: 'USR004', name: 'Tan Wei Ling', role: 'individual_agent' },
  AGENT_3: { id: 'USR009', name: 'Kavitha a/p Muthusamy', role: 'individual_agent' },
  AGENT_4: { id: 'USR012', name: 'Amir Hamzah bin Yusof', role: 'individual_agent' },
  AGENT_5: { id: 'USR016', name: 'Saravanan a/l Krishnan', role: 'individual_agent' },
  AGENT_6: { id: 'USR020', name: 'Chandra a/l Segaran', role: 'individual_agent' },
};

let _commId = 0;
const nextCommId = () => `CM-${String(++_commId).padStart(4, '0')}`;

// Helper — builds a commission entry with all required fields
const buildCommission = ({
  recipient, type, perCase, tiers, effectiveFrom, approvalStatus = 'active', createdBy = 'USR005',
}) => ({
  id: nextCommId(),
  agentType: recipient.role,
  recipientId: recipient.id,
  recipientName: recipient.name,
  recipientRole: recipient.role,
  commissionType: type,
  perCaseAmount: type === 'per_case' ? perCase : null,
  tiers: type === 'percentage' ? tiers : [],
  effectiveFrom,
  effectiveTo: null,
  supersededBy: null,
  approvalStatus,
  l1ApprovedBy: approvalStatus === 'active' ? 'USR005' : null,
  l1ApprovedAt: approvalStatus === 'active' ? effectiveFrom : null,
  l2ApprovedBy: approvalStatus === 'active' ? 'USR010' : null,
  l2ApprovedAt: approvalStatus === 'active' ? effectiveFrom : null,
  createdBy,
  createdAt: effectiveFrom,
});

export const initialProductConfigs = [
  {
    id: 'PC-0001',
    productCode: 'IMY-PL-RHB-001',
    category: 'personal_loan',
    lenderName: 'RHB',
    productName: 'RHB Easy-Pinjaman Ekspres',
    contractStartDate: toISO(addMonths(today, -10)),
    contractExpireDate: toISO(addMonths(today, 2)),
    contractDuration: 12,
    approvalStatus: 'active',
    commissions: [
      buildCommission({
        recipient: RECIPIENTS.PARTNER_1, type: 'percentage',
        tiers: [
          { min: 0, max: 50000, rate: 1.5 },
          { min: 50001, max: 200000, rate: 1.2 },
          { min: 200001, max: null, rate: 0.8 },
        ],
        effectiveFrom: toISO(addMonths(today, -10)),
      }),
      buildCommission({
        recipient: RECIPIENTS.PARTNER_2, type: 'percentage',
        tiers: [
          { min: 0, max: 100000, rate: 1.3 },
          { min: 100001, max: null, rate: 1.0 },
        ],
        effectiveFrom: toISO(addMonths(today, -10)),
      }),
      buildCommission({
        recipient: RECIPIENTS.AGENT_1, type: 'percentage',
        tiers: [
          { min: 0, max: 50000, rate: 1.0 },
          { min: 50001, max: null, rate: 0.8 },
        ],
        effectiveFrom: toISO(addMonths(today, -10)),
      }),
    ],
    createdBy: 'USR005',
    createdAt: toISO(addMonths(today, -10)),
    updatedAt: toISO(addMonths(today, -10)),
  },
  {
    id: 'PC-0002',
    productCode: 'IMY-PL-ALL-001',
    category: 'personal_loan',
    lenderName: 'ALLIANCE',
    productName: 'Alliance CashVantage Personal Financing',
    contractStartDate: toISO(addMonths(today, -3)),
    contractExpireDate: toISO(addMonths(today, 21)),
    contractDuration: 24,
    approvalStatus: 'active',
    commissions: [
      buildCommission({
        recipient: RECIPIENTS.PARTNER_1, type: 'percentage',
        tiers: [
          { min: 0, max: 50000, rate: 1.3 },
          { min: 50001, max: null, rate: 1.0 },
        ],
        effectiveFrom: toISO(addMonths(today, -3)),
      }),
      buildCommission({
        recipient: RECIPIENTS.AGENT_2, type: 'percentage',
        tiers: [{ min: 0, max: null, rate: 0.9 }],
        effectiveFrom: toISO(addMonths(today, -3)),
      }),
    ],
    createdBy: 'USR005',
    createdAt: toISO(addMonths(today, -3)),
    updatedAt: toISO(addMonths(today, -3)),
  },
  {
    id: 'PC-0003',
    productCode: 'IMY-CC-RHB-GOLD',
    category: 'credit_card',
    lenderName: 'RHB',
    productName: 'RHB Cashback Gold Mastercard',
    contractStartDate: toISO(addMonths(today, -6)),
    contractExpireDate: toISO(addMonths(today, 6)),
    contractDuration: 12,
    approvalStatus: 'active',
    commissions: [
      buildCommission({
        recipient: RECIPIENTS.PARTNER_1, type: 'per_case', perCase: 50,
        effectiveFrom: toISO(addMonths(today, -6)),
      }),
      buildCommission({
        recipient: RECIPIENTS.PARTNER_2, type: 'per_case', perCase: 60,
        effectiveFrom: toISO(addMonths(today, -6)),
      }),
      buildCommission({
        recipient: RECIPIENTS.AGENT_1, type: 'per_case', perCase: 35,
        effectiveFrom: toISO(addMonths(today, -6)),
      }),
    ],
    createdBy: 'USR005',
    createdAt: toISO(addMonths(today, -6)),
    updatedAt: toISO(addMonths(today, -6)),
  },
  {
    id: 'PC-0004',
    productCode: 'IMY-CC-MBB-PET',
    category: 'credit_card',
    lenderName: 'Maybank',
    productName: 'Maybank Petronas Visa Card',
    contractStartDate: toISO(addMonths(today, -13)),
    contractExpireDate: toISO(addMonths(today, -1)),
    contractDuration: 12,
    approvalStatus: 'active',
    commissions: [
      buildCommission({
        recipient: RECIPIENTS.PARTNER_3, type: 'per_case', perCase: 80,
        effectiveFrom: toISO(addMonths(today, -13)),
      }),
    ],
    createdBy: 'USR005',
    createdAt: toISO(addMonths(today, -13)),
    updatedAt: toISO(addMonths(today, -13)),
  },
  {
    id: 'PC-0005',
    productCode: 'IMY-HL-MBSB-001',
    category: 'housing_loan',
    lenderName: 'MBSB',
    productName: 'MBSB Home Financing-i',
    contractStartDate: toISO(addMonths(today, -4)),
    contractExpireDate: toISO(addMonths(today, 20)),
    contractDuration: 24,
    approvalStatus: 'active',
    commissions: [
      buildCommission({
        recipient: RECIPIENTS.PARTNER_2, type: 'percentage',
        tiers: [
          { min: 0, max: 500000, rate: 0.5 },
          { min: 500001, max: null, rate: 0.4 },
        ],
        effectiveFrom: toISO(addMonths(today, -4)),
      }),
      buildCommission({
        recipient: RECIPIENTS.AGENT_3, type: 'percentage',
        tiers: [{ min: 0, max: null, rate: 0.3 }],
        effectiveFrom: toISO(addMonths(today, -4)),
      }),
    ],
    createdBy: 'USR005',
    createdAt: toISO(addMonths(today, -4)),
    updatedAt: toISO(addMonths(today, -4)),
  },
  {
    id: 'PC-0006',
    productCode: 'IMY-BL-FS-001',
    category: 'business_loan',
    lenderName: 'Funding Societies',
    productName: 'Funding Societies SME Loan',
    contractStartDate: toISO(addMonths(today, -1)),
    contractExpireDate: toISO(addMonths(today, 11)),
    contractDuration: 12,
    approvalStatus: 'pending_l1',
    commissions: [
      buildCommission({
        recipient: RECIPIENTS.PARTNER_3, type: 'per_case', perCase: 1500,
        effectiveFrom: toISO(addMonths(today, -1)),
        approvalStatus: 'pending_l1',
      }),
    ],
    createdBy: 'USR005',
    createdAt: toISO(addMonths(today, -1)),
    updatedAt: toISO(addMonths(today, -1)),
  },
  {
    id: 'PC-0007',
    productCode: 'IMY-GL-BSN-001',
    category: 'government_loan',
    lenderName: 'BSN',
    productName: 'BSN MyRinggit-i',
    contractStartDate: toISO(addMonths(today, -2)),
    contractExpireDate: toISO(addMonths(today, 10)),
    contractDuration: 12,
    approvalStatus: 'active',
    commissions: [
      buildCommission({
        recipient: RECIPIENTS.PARTNER_1, type: 'percentage',
        tiers: [{ min: 0, max: null, rate: 0.75 }],
        effectiveFrom: toISO(addMonths(today, -2)),
      }),
      buildCommission({
        recipient: RECIPIENTS.AGENT_4, type: 'percentage',
        tiers: [{ min: 0, max: null, rate: 0.5 }],
        effectiveFrom: toISO(addMonths(today, -2)),
      }),
    ],
    createdBy: 'USR005',
    createdAt: toISO(addMonths(today, -2)),
    updatedAt: toISO(addMonths(today, -2)),
  },
  {
    id: 'PC-0008',
    productCode: 'IMY-ML-TMB-001',
    category: 'micro_loan',
    lenderName: 'Tamabadana',
    productName: 'Tamabadana Micro Financing',
    contractStartDate: toISO(addMonths(today, -5)),
    contractExpireDate: toISO(addMonths(today, 7)),
    contractDuration: 12,
    approvalStatus: 'active',
    commissions: [
      buildCommission({
        recipient: RECIPIENTS.PARTNER_2, type: 'per_case', perCase: 150,
        effectiveFrom: toISO(addMonths(today, -5)),
      }),
      buildCommission({
        recipient: RECIPIENTS.AGENT_5, type: 'per_case', perCase: 100,
        effectiveFrom: toISO(addMonths(today, -5)),
      }),
      buildCommission({
        recipient: RECIPIENTS.AGENT_6, type: 'per_case', perCase: 100,
        effectiveFrom: toISO(addMonths(today, -5)),
      }),
    ],
    createdBy: 'USR005',
    createdAt: toISO(addMonths(today, -5)),
    updatedAt: toISO(addMonths(today, -5)),
  },
];

// ─── Initial Audit Logs ────────────────────────────────────────────
export const initialAuditLogs = [
  {
    id: 'LOG-0001',
    timestamp: toISO(addMonths(today, -10)) + 'T09:00:00Z',
    userId: 'USR004',
    userName: 'Admin User',
    userRole: 'admin',
    action: 'create_product',
    entityType: 'product_config',
    entityId: 'PC-0001',
    description: 'Imported RHB Personal Loan from imoney.my API',
    reason: 'New lender partnership Q2 2026',
  },
  {
    id: 'LOG-0002',
    timestamp: toISO(addMonths(today, -10)) + 'T10:15:00Z',
    userId: 'USR005',
    userName: 'Manager L1',
    userRole: 'admin',
    action: 'approve_l1',
    entityType: 'product_config',
    entityId: 'PC-0001',
    description: 'L1 approval granted for RHB Personal Loan',
    reason: 'Terms align with Q2 strategy',
  },
  {
    id: 'LOG-0003',
    timestamp: toISO(addMonths(today, -10)) + 'T14:00:00Z',
    userId: 'USR006',
    userName: 'Senior Manager L2',
    userRole: 'admin',
    action: 'approve_l2',
    entityType: 'product_config',
    entityId: 'PC-0001',
    description: 'L2 approval — product now active',
    reason: 'Final compliance review passed',
  },
  {
    id: 'LOG-0004',
    timestamp: toISO(addMonths(today, -6)) + 'T11:30:00Z',
    userId: 'USR004',
    userName: 'Admin User',
    userRole: 'admin',
    action: 'create_product',
    entityType: 'product_config',
    entityId: 'PC-0003',
    description: 'Imported RHB Cashback Gold Mastercard',
    reason: 'Credit card portfolio expansion',
  },
  {
    id: 'LOG-0005',
    timestamp: toISO(addMonths(today, -1)) + 'T08:45:00Z',
    userId: 'USR004',
    userName: 'Admin User',
    userRole: 'admin',
    action: 'create_product',
    entityType: 'product_config',
    entityId: 'PC-0006',
    description: 'Submitted Funding Societies SME Loan for approval',
    reason: 'New SME lending partner',
  },
];
